
import Vue from "vue";
import { BrowseStateBase } from "@/utils/browse/browse-state-base";

export default Vue.extend({
	props: {
		item: {
			type: Object as () => any,
			required: true
		},
		state: {
			type: Object as () => BrowseStateBase,
			required: true
		}
	},
	computed: {
		loaded():boolean {
			return this.state.sidebarItemLoaded;
		},
		url():string {
			let cover = this.item.CoverImage;
			if (cover && cover.ID && cover.getFileUrl) return cover.getFileUrl();
			let images = this.item.Images || [];
			if (images.length > 0 && images[0].getFileUrl) return images[0].getFileUrl();
			return "";
		}
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
